export const EXPENSE_TYPES = {
  expense: 'Wydatek',
  income: 'Przychód'
}
